/**
 * Returns true only for relative paths that can safely be redirected to without
 * letting an attacker bounce the user to an external origin.
 *
 * Rejects everything that isn't an unambiguous same-origin path:
 * - Non-strings.
 * - Empty strings.
 * - Anything not starting with a single `/` (covers `https://evil.com`,
 *   `javascript:...`, `data:...`, plain `foo`, `./foo`, `../foo`, `\\evil.com`).
 * - Protocol-relative URLs (`//evil.com`).
 * - Backslash-prefixed paths (`/\evil.com`) — some legacy clients normalize `\`
 *   to `/`, which would re-introduce the protocol-relative escape.
 */
export function isSafeRedirect(value: unknown): boolean {
  if (typeof value !== 'string') return false;
  if (value.length === 0) return false;
  if (value[0] !== '/') return false;
  if (value[1] === '/') return false;
  if (value[1] === '\\') return false;
  return true;
}
